:root ._ff-f-family{font-family:var(--f-family);}
:root ._dsp-inline{display:inline;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._ww-break-word{word-wrap:break-word;}
:root ._ws-pre-wrap{white-space:pre-wrap;}
:root ._mt-0px{margin-top:0px;}
:root ._mr-0px{margin-right:0px;}
:root ._mb-0px{margin-bottom:0px;}
:root ._ml-0px{margin-left:0px;}
:root ._col-color{color:var(--color);}
:root ._cur-pointer{cursor:pointer;}
:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fb-auto{flex-basis:auto;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-column{flex-direction:column;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._width-10037{width:100%;}
:root ._fd-row{flex-direction:row;}
:root ._justify-space-betwe3241{justify-content:space-between;}
:root ._items-flex-start{align-items:flex-start;}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._items-center{align-items:center;}
:root ._self-center{align-self:center;}
:root ._mt-t-space-med104641{margin-top:var(--t-space-medium);}
:root ._mr-t-space-med104641{margin-right:var(--t-space-medium);}
:root ._mb-t-space-med104641{margin-bottom:var(--t-space-medium);}
:root ._ml-t-space-med104641{margin-left:var(--t-space-medium);}